import { useViewportSize } from "@mantine/hooks";

export const useViewportHeight = () => {
  const { height: viewportHeight } = useViewportSize();

  return viewportHeight || "100vh";
};
